import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { AddButton, ExportButton } from '_components';
import styles from './Common.module.css';
import { PatientCareCenterNoteGoalsIndHep } from './IndHep';
import { PatientCareCenterNoteGoalsLTGDetails } from './LTGDetails';
import { PedsGoalsRow } from './PedsGoalsRow';
import { GoalTemplate } from './GoalsTemplate';
class PatientCareCenterNoteGoalsLTGs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: '-1',
        }
        this.onChange = this.onChange.bind(this)
    };

    async onChange(event) {
        await this.setState({ selectedDate: event.target.value });

        this.props.updateDatesLTG(this.props.noteId, event.target.value);

        // let value = '';
        // let date = new Date();
        // value = date.setTime(date.getTime() + event.target.value * 86400000);
        // Object.keys(this.props.allGoals)
        //     .forEach(x => {
        //         if (this.props.allGoals[x].GOGPNO !== 11) {
        //             this.props.updateDateField(this.props.noteId, 'PTGOALS', 'GONO', this.props.allGoals[x].GONO, 'GODATE', value);
        //         }
        //     });
    }

    addGoal() {

        if (this.state.selectedDate !== '-1' && this.state.selectedDate !== '0') {
            var goalDate = new Date();
            goalDate.setDate(goalDate.getDate() + parseInt(this.state.selectedDate));
            this.props.addGoal(this.props.noteId, undefined, undefined, goalDate.toISOString().split('T')[0]);
        } else {
            this.props.addGoal(this.props.noteId);
        }
        if (!this.props.goalsUpdated && this.props.noteType !== 1) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }

    addCustomGoal() {
        if (this.state.selectedDate !== '-1' && this.state.selectedDate !== '0') {
            var goalDate = new Date();
            goalDate.setDate(goalDate.getDate() + parseInt(this.state.selectedDate));
            this.props.addCustomGoal(this.props.noteId, this.props.isWc, goalDate.toISOString().split('T')[0]);
        } else {
            this.props.addCustomGoal(this.props.noteId, this.props.isWc);
        }

        if (!this.props.goalsUpdated && this.props.noteType !== 1) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }

    convertNote() {
        this.props.convertNote(this.props.noteId, 5); // PN/DN
    }

    render() {

        let options = [
            { id: '7', value: '1 Week', days: 7 },
            { id: '14', value: '2 Week', days: 14 },
            { id: '21', value: '3 Week', days: 21 },
            { id: '28', value: '4 Week', days: 28 },
            { id: '35', value: '5 Week', days: 35 },
            { id: '42', value: '6 Week', days: 42 },
            { id: '49', value: '7 Week', days: 49 },
            { id: '56', value: '8 Week', days: 56 },
            { id: '90', value: '3 Months', days: 90 },
            { id: '120', value: '4 Months', days: 120 },
            { id: '150', value: '5 Months', days: 150 },
            { id: '180', value: '6 Months', days: 180 },
            { id: '210', value: '7 Months', days: 210 },
            { id: '230', value: '8 Months', days: 230 }
        ];


        return (
            <div>
                <div className={styles.stg_header_wrapper}>
                    <div className={styles.stg_header_row}>
                        <div className={styles.stg_header_1}>Long Term Goals</div>

                        {this.props.noteType !== 2 && this.props.noteType !== 4 && this.props.noteType !== 6 &&
                            <>
                                <div className={styles.stg_header_2}>Default all dates to:</div>
                                <div className={styles.stg_header_3}>
                                    <div></div>
                                    <select className={styles.stg_default_dropdown} value={this.state.selectedDate} onChange={(event) => this.onChange(event)}>
                                        <option key={0} value={0}></option>
                                        {Object.keys(options)
                                            .map(id => {
                                                const option = options[id];
                                                return (
                                                    <option key={option.id} value={option.id} days={option.days}>{option.value}</option>
                                                );
                                            })
                                        }
                                    </select>
                                </div>
                                {this.props.noteType !== 1 &&
                                    <>
                                        <span className={styles.goal_detail_prog_dropdown_stg}>
                                        </span>
                                        {this.props.noteType !== 2 &&
                                            <div className={styles.goal_detail_copy_col}>
                                            </div>
                                        }

                                    </>
                                }
                            </>
                        }

                    </div>
                </div>

                {this.props.isTemplateVisible &&
                    <GoalTemplate />
                }

                <PatientCareCenterNoteGoalsIndHep days={this.props.defaultLongDate} />



                {this.props.isWc && !this.props.pdc &&
                    <span className={styles.pdc_warning}>
                        The patient's Job Required PDC level has not yet been determined in the Subjective section of the note.  This section must be completed prior to
                        adding goals.  <span className={styles.pdc_link} onClick={() => this.props.subjectiveRefProp.current.scrollIntoView({ behavior: 'smooth', block: 'start' })}>Click here</span> to enter the PDC criteria.
                    </span>
                }




                {(!this.props.isWc || (this.props.isWc && this.props.pdc)) &&
                    <div className={styles.goals_wrapper}>
                        {(!this.props.isPeds || !this.props.isPedsEnabled) && (!this.props.isPedsSpeech || !this.props.isSpeechEnabled) &&
                            <>
                                <div className={styles.goal_header}>
                                    {(this.props.noteType === 1 || this.props.noteType === 3 || this.props.noteType === 5) &&
                                        <>
                                            <span className={styles.add_button_wrapper}>
                                                <AddButton size='extra-small' title={this.props.isWc ? 'Add New Work Goal' : 'Add New Functional Goal'} onClick={() => this.addGoal()} />
                                            </span>
                                            <span className={styles.goal_header_title}>Functional Goal</span>
                                        </>
                                    }
                                    <div className={styles.goal_header_label_wrapper}>
                                        <div className={styles.goal_detail_col1}></div>
                                        <div className={styles.ltg_activity_dropdown}>Activity</div>
                                        <div className={styles.ltg_plof_clof_goal}>PLOF</div>
                                        <div className={styles.ltg_plof_clof_goal}>CLOF
                                        </div>
                                        <div className={styles.ltg_plof_clof_goal}>Goal</div>
                                        <div className={styles.stg_date}>Date</div>
                                        {(this.props.noteType !== 1) &&
                                            <div className={styles.goal_detail_prog_dropdown_stg}>Progress</div>
                                        }
                                        {(this.props.noteType === 3 || this.props.noteType === 5) &&
                                            <div className={styles.goal_detail_copy_col} />
                                        }
                                    </div>
                                </div>
                                {Object.keys(this.props.goals)
                                    .map(key => {
                                        const result = this.props.goals[key];
                                        return (
                                            <PatientCareCenterNoteGoalsLTGDetails key={result.GONO} id={result.GONO} />
                                        )
                                    })
                                }
                            </>
                        }
                    </div>
                }
                {(!this.props.isPeds || !this.props.isPedsEnabled) && (!this.props.isPedsSpeech || !this.props.isSpeechEnabled) &&
                    <div className={styles.goal_header}>
                        {(this.props.noteType === 1 || this.props.noteType === 3 || this.props.noteType === 5) &&
                            <span className={styles.add_button_wrapper}>
                                <AddButton size='extra-small' title={this.props.isWc ? 'Add New Custom Work Goal' : 'Add New Custom Functional Goal'} onClick={() => this.addCustomGoal()} disabled={this.props.disabled} />
                            </span>
                        }
                        <span className={styles.goal_header_title}>Custom Activity</span>

                        {Object.keys(this.props.customGoals)
                            .map(key => {
                                const result = this.props.customGoals[key];
                                return (
                                    <PatientCareCenterNoteGoalsLTGDetails key={result.GONO} id={result.GONO} />
                                )
                            })
                        }
                    </div>
                }

                {((this.props.isPeds && this.props.isPedsEnabled) || (this.props.isPedsSpeech && this.props.isSpeechEnabled)) &&
                    <div className={styles.goal_header}>
                        {(this.props.noteType === 1 || this.props.noteType === 3 || this.props.noteType === 5) &&
                            <span className={styles.add_button_wrapper}>
                                <AddButton title='Add New Peds Goal' size='extra-small' onClick={() => this.addGoal()} />

                            </span>
                        }
                        <span className={styles.goal_header_title}>Peds Goal</span>
                        <span>
                            <div className={styles.column_header_activity}>Activity</div>
                            <div className={styles.column_header_assistance}>Level of Assistance</div>
                            <div className={styles.column_header}>Description</div>
                            <div className={styles.column_header}></div>
                        </span>

                        {Object.keys(this.props.goals)
                            .map(key => {
                                const result = this.props.goals[key];
                                return (
                                    <PedsGoalsRow key={result.GONO} id={result.GONO} />
                                )
                            })
                        }
                    </div>
                }
                {((this.props.isPeds && this.props.isPedsEnabled) || (this.props.isPedsSpeech && this.props.isSpeechEnabled)) &&
                    <div className={styles.goal_header}>
                        {(this.props.noteType === 1 || this.props.noteType === 3 || this.props.noteType === 5) &&
                            <span className={styles.add_button_wrapper}>
                                <AddButton size='extra-small' title={'Add New Custom Goal'} onClick={() => this.addCustomGoal()} disabled={this.props.disabled} />
                            </span>
                        }
                        <span className={styles.goal_header_title}>Custom Goals</span>

                        {Object.keys(this.props.customGoals)
                            .map(key => {
                                const result = this.props.customGoals[key];
                                return (
                                    <PedsGoalsRow key={result.GONO} id={result.GONO} />
                                )
                            })
                        }
                    </div>
                }

                {this.props.noteType === 2 &&
                    <div>
                        <div className={styles.goal_detail_row}>
                            <label className={styles.convert_msg}>Need to edit additional goal details?  Convert this note to a PN by clicking here:</label>
                        </div>
                        <div className={styles.goal_detail_row}>
                            <span className={styles.convert_button}>
                                <ExportButton title='Convert to PN/DN' size='large' onClick={() => this.convertNote()} />
                            </span>
                        </div>
                    </div>
                }
            </div >
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addGoal: bindActionCreators(noteActions.addGoal, dispatch),
        addCustomGoal: bindActionCreators(noteActions.addCustomGoal, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        convertNote: bindActionCreators(noteActions.convert, dispatch),
        updateDateField: bindActionCreators(noteActions.updateDateField, dispatch),
        updateDatesLTG: bindActionCreators(noteActions.updateDatesLTG, dispatch),
        addChildRow: bindActionCreators(noteActions.addChildRow, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isWc = state.entities.admissions[epno].isWc;
    let pdc = undefined;
    let disabled = true;

    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;

    let isPedsSpeech = state.entities.admissions[epno].isPedsSpeech;
    let isSpeechEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
    let isTemplateVisible = false;

    let templates = Object.keys(state.entities.notes.PTGOALTEMPLATE)
        .filter(x => {
            return ((state.entities.notes.PTGOALTEMPLATE[x].NoteId == noteId));
        })
        .sort((a, b) => state.entities.notes.PTGOALTEMPLATE[a].GTORDER - state.entities.notes.PTGOALTEMPLATE[b].GTORDER)
        .map(key => state.entities.notes.PTGOALTEMPLATE[key]);

    if (Object.keys(state.entities.notes.PTGOALTEMPLATE)
        .filter(x => {
            return ((state.entities.notes.PTGOALTEMPLATE[x].NoteId == noteId));
        }).length > 0) {
        isTemplateVisible = true;
    }



    if (noteType === 1 || noteType === 3 || noteType === 5) {
        disabled = false;
    }

    let defaultLongDate = state.ui.notes[noteId].defaultLongDate;
    if (isWc) {
        if (noteType === 1) {
            if (state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC) {
                pdc = state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC;
            }
        } else {
            if (state.entities.notes.PTEVAL[pk] !== undefined) {
                pdc = state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC
            }
            else {
                pdc = state.entities.admissions[epno].jobReqPdc;
            }
        }
    }


    let goalsUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTGOALSUPDATED : true;

    let allGoals = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return (
                (noteType === 1 && state.entities.notes.PTGOALS[key].GOEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALS[key].GONTNO === pk)
            ) &&
                (state.entities.notes.PTGOALS[key].GODELETED !== true ||
                    (state.entities.notes.PTGOALS[key].GODELETED === true && state.entities.notes.PTGOALS[key].GOGONO)
                )
        })
        .sort((a, b) => {
            return state.entities.notes.PTGOALS[b].GONO - state.entities.notes.PTGOALS[a].GONO;
        })
        .map(key => state.entities.notes.PTGOALS[key]);

    let goals = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return (
                (noteType === 1 && state.entities.notes.PTGOALS[key].GOEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALS[key].GONTNO === pk)
            ) && state.entities.notes.PTGOALS[key].GODELETED !== true
                && state.entities.notes.PTGOALS[key].GOMGNO !== parseInt(state.entities.masterData.PROPS['PTERO_IND_HEP_GOAL_ID'].PRVALUE)
                && state.entities.notes.PTGOALS[key].GOMGNO !== parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID'].PRVALUE)
                && state.entities.notes.PTGOALS[key].GOMGNO !== parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID_WC'].PRVALUE)
                && state.entities.notes.PTGOALS[key].GOMGNO !== parseInt(state.entities.masterData.PROPS['PTERO_FREE_FORM_GOAL_ID'].PRVALUE)
        })
        .sort((a, b) => {
            return state.entities.notes.PTGOALS[b].GONO - state.entities.notes.PTGOALS[a].GONO;
        })
        .map(key => state.entities.notes.PTGOALS[key]);
    let customGoals = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return ((noteType === 1 && state.entities.notes.PTGOALS[key].GOEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALS[key].GONTNO === pk)) &&
                (state.entities.notes.PTGOALS[key].GODELETED !== true)
                && (state.entities.notes.PTGOALS[key].GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID'].PRVALUE)
                    || state.entities.notes.PTGOALS[key].GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID_WC'].PRVALUE))
        })
        .sort((a, b) => {
            return state.entities.notes.PTGOALS[b].GONO - state.entities.notes.PTGOALS[a].GONO;
        })
        .map(key => state.entities.notes.PTGOALS[key]);

    return {
        noteId: noteId,
        noteType: noteType,
        pk: pk,
        isWc: isWc,
        pdc: pdc,
        fotoActivities: Object.keys(state.entities.notes.FOTOPATIENTRESPONSE)
            .filter(key => {
                return (noteType === 1 && state.entities.notes.FOTOPATIENTRESPONSE[key].PREVNO === pk) ||
                    (noteType !== 1 && state.entities.notes.FOTOPATIENTRESPONSE[key].PRNTNO === pk)
            })
            .sort((a, b) => state.entities.notes.FOTOPATIENTRESPONSE[a].FOTOPRNO - state.entities.notes.FOTOPATIENTRESPONSE[b].FOTOPRNO)
            .map(key => state.entities.notes.FOTOPATIENTRESPONSE[key]),
        goals,
        customGoals,
        goalsUpdated,
        defaultLongDate,
        disabled,
        allGoals,
        isPeds,
        isPedsEnabled,
        isPedsSpeech,
        isSpeechEnabled,
        isTemplateVisible
    };
}

const connectedPatientCareCenterNoteGoalsLTGs = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsLTGs);
export { connectedPatientCareCenterNoteGoalsLTGs as PatientCareCenterNoteGoalsLTGs };

